(function () {
  function initCustomerLoveArrows() {
    var section = document.querySelector('.customer-love');
    if (!section) return;

    var slider = section.querySelector('#customerReviews');
    var prev = section.querySelector('.nav-btn.prev');
    var next = section.querySelector('.nav-btn.next');
    if (!slider || !prev || !next) return;

    var lastScrollLeft = slider.scrollLeft;

    function setActive(button) {
      prev.classList.toggle('is-scroll-active', button === prev);
      next.classList.toggle('is-scroll-active', button === next);
    }

    setActive(prev);

    prev.addEventListener('click', function () {
      setActive(prev);
    });

    next.addEventListener('click', function () {
      setActive(next);
    });

    slider.addEventListener(
      'scroll',
      function () {
        var currentScrollLeft = slider.scrollLeft;

        if (currentScrollLeft > lastScrollLeft + 2) {
          setActive(next);
        } else if (currentScrollLeft < lastScrollLeft - 2) {
          setActive(prev);
        }

        lastScrollLeft = currentScrollLeft;
      },
      { passive: true }
    );
  }

  function initKidsCareArrows() {
    var section = document.querySelector('.kids-care-section');
    if (!section) return;

    var track = section.querySelector('.kids-care-track');
    var prev = section.querySelector('.kids-care-prev');
    var next = section.querySelector('.kids-care-next');
    if (!track || !prev || !next) return;

    var lastScrollLeft = track.scrollLeft;

    function setActive(button) {
      prev.classList.toggle('is-scroll-active', button === prev);
      next.classList.toggle('is-scroll-active', button === next);
    }

    setActive(prev);

    prev.addEventListener('click', function () {
      setActive(prev);
    });

    next.addEventListener('click', function () {
      setActive(next);
    });

    track.addEventListener(
      'scroll',
      function () {
        var currentScrollLeft = track.scrollLeft;

        if (currentScrollLeft > lastScrollLeft + 2) {
          setActive(next);
        } else if (currentScrollLeft < lastScrollLeft - 2) {
          setActive(prev);
        }

        lastScrollLeft = currentScrollLeft;
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCustomerLoveArrows();
      initKidsCareArrows();
    });
  } else {
    initCustomerLoveArrows();
    initKidsCareArrows();
  }
})();
